import React from 'react';
import './Home.css';
import { connect } from 'react-redux';
import { getCurrentUser } from '../actions';
import { Link } from 'react-router-dom';
import config from '../config';
import { Redirect } from 'react-router-dom';
import { apiGet } from '../services/apiService';
import { MDBContainer, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';

class Home extends React.Component {

    state = {
        protivitiClients: []
    };

    constructor(props) {
        super(props);
        this.state = {
            noticeModal: false,
            count: 1
        }
    }

    async componentDidMount() {
        await this.fetchProtivitiClients();
    }

    // TODO: remove this after 11/01/2025
    componentDidUpdate(prevProps) {
        const currentDate = new Date();
        const endDate = new Date("11/01/2025")
        if (prevProps.userReducer.currentUser !== this.props.userReducer.currentUser && this.state.count === 1 && currentDate < endDate) {
            if (this.props.userReducer.currentUser.isAdmin || (this.props.userReducer.currentUser.emailAddress && this.isProtivitiRH(this.props.userReducer.currentUser.emailAddress))) {
                this.setState({ noticeModal: true, count: 2 });
            }
        }
    }

    fetchProtivitiClients = async () => {
        const url = config.azRedirectUri + '/api/Config/protiviticlients';
        apiGet(url)
            .then((response) => {
                this.setState({ protivitiClients: response.data });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    isProtivitiRH(email) {
        if (!email) return false;
        const domains = ["roberthalf.com", "roberthalf.net", "protiviti.com"];
        const domain = email.split('@')[1];
        return domains.includes(domain);
    }

    extendAlert() {
        return (
            this.props.sharedReducer.extendAlert ?
                <div className='alert alert-success' role='alert'>
                    Success! Expiration date for <b>{this.props.sharedReducer.extendAlert}</b> is extended to 90 days from today.
                </div> : null
        );
    }

    toggleNoticeModal = () => {
        this.setState({
            noticeModal: !this.state.noticeModal
        });
    }

    renderNoticeModal() {
        return (
            <MDBContainer>
                <MDBModal isOpen={this.state.noticeModal} toggle={this.toggleNoticeModal} backdrop={false}>
                    <MDBModalHeader toggle={this.toggle}>Teams Request Moved</MDBModalHeader>
                    <MDBModalBody>
                        This tool has been replaced for adding Guests to Teams. Now, navigate to Teams - MyHub - Start a Request - Add Member Firm Guest to Workspace.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <button className='btn btn-primary updateButton' onClick={this.toggleNoticeModal}>OK</button>
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        );
    }

    render() {
        return (
            <div>
                {this.props.userReducer.currentUser && this.props.userReducer.currentUser.emailAddress &&
                    <div className='home mt-20'>
                        <div className="row">
                            <div className="col-md-1">
                            </div>
                            <div className="col-md-10">
                                {this.extendAlert()}
                                <h1>Hello, {this.props.userReducer.currentUser.firstName}!</h1>

                                <div className="menu">
                                    <div className="menu-row">
                                        {(this.props.userReducer.currentUser.isAdmin || this.props.userReducer.currentUser.isDelegate) &&
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <Link to='/accountmanagement'><img className="home-icons" src="images/Manage_MF_Accounts.png" alt="Manage_MF_Accounts" /></Link>
                                                </div>
                                            </div>
                                        }

                                        {this.props.userReducer.currentUser.isAdmin &&
                                            <div className="menu-row mt-30 mb-30">
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <Link to='/delegates'><img className="home-icons" src="images/Manage_Delegates.png" alt="Manage_Delegates" /></Link>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <Link to='/offices'><img className="home-icons" src="images/Manage_Offices.png" alt="Manage_Offices" /></Link>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <Link to={{ pathname: '/systemconfig/auditlogs', state: { type: 'auditlog' } }}><img className="home-icons" src="images/View_Audit_Logs.png" alt="View_Audit_Logs" /></Link>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <Link to={{ pathname: '/systemconfig/emailwhitelist', state: { type: 'whitelist' } }}><img className="home-icons" src="images/Manage_Whitelist.png" alt="Manage_Whitelist" /></Link>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <Link to={{ pathname: '/systemconfig/emailblacklist', state: { type: 'blacklist' } }}><img className="home-icons" src="images/Manage_Blacklist.png" alt="Manage_Blacklist" /></Link>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.props.userReducer.currentUser.emailAddress && !this.props.userReducer.currentUser.isAdmin && !this.props.userReducer.currentUser.isDelegate && !this.isProtivitiRH(this.props.userReducer.currentUser.emailAddress) &&
                                            <Redirect to='/passwordreset' />
                                        }
                                    </div>
                                </div>
                                <div className="col-md-1">
                                </div>
                            </div>
                        </div>
                        {this.renderNoticeModal()}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sharedReducer: state.sharedReducer,
        userReducer: state.userReducer
    }
}

export default connect(mapStateToProps, { getCurrentUser })(Home);